<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Activités de l'officine (3/4)">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Technologies pharmaceutiques
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Activités de préparations magistrales de l’officine
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preparationMagistrale"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preparationMagistrale"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preparationMagistrale"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.preparationMagistrale">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.moyennePreparation"
                label="Moyenne des préparations effectuées mensuellement"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187;Activités de préparations sous-traitées
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.soustraitancePreparation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  value="oui"
                  name="soustraitancePreparation"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  value="non"
                  name="soustraitancePreparation"
                  required
                ></v-radio>
                <v-radio
                  label="en partie"
                  value="en partie"
                  name="soustraitancePreparation"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="isSousTraitance">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.moyenneSoustraitancePreparation"
                label="Moyenne des préparations sous-traitées mensuellement"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Respect des Bonnes Pratiques de Préparations
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.bppRespect"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="bppRespect"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="bppRespect"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Autorisation d’exécution de préparations à risque pour la
                santé
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preparationRisque"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preparationRisque"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preparationRisque"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Agrément spécifique aux préparations dangereuses stériles
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.agrementPreparationDangereuse"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="agrementPreparationDangereuse"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="agrementPreparationDangereuse"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Préparation par voie orale pour les enfants de moins de
                12 ans avec des produits listés
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preprationEnfant"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preprationEnfant"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preprationEnfant"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="dossier.preparatoireSurface"
                :rules="numberRules"
                label="Surface du préparatoire (en m²)"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Préparatoire fermé
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preparatoireFerme"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preparatoireFerme"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preparatoireFerme"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Emplacement réservé aux préparations
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preparationEspaceReserve"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preparationEspaceReserve"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preparationEspaceReserve"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Balance contrôlée annuellement
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.controleBalance"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="controleBalance"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="controleBalance"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Préparation de doses à administrer (PDA)
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preparationPDA"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preparationPDA"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preparationPDA"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.preparationPDA">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.modalitePDA"
                label="Si oui, quelles sont les modalités d’organisation de la PDA au sein de l’officine ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Espace dédié à la PDA
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.espaceDPA"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="espaceDPA"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="espaceDPA"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Emplacement réservé pour les Médicaments Non Utilisés
                (MNU)
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.espaceMNU"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="espaceMNU"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="espaceMNU"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Emplacement réservé pour les Déchets d’Activités de Soins
                à Risques Infectieux (DASRI)
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.espaceDASRI"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="espaceDASRI"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="espaceDASRI"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie10",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?(^[0-9]+$)$/.test(v) || "La superficie doit être un nombre entier"
    ]
  }),
  computed: {
    isSousTraitance() {
      return (
        this.dossier.soustraitancePreparation == "oui" ||
        this.dossier.soustraitancePreparation == "en partie"
      );
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!this.dossier.preparationMagistrale)
          this.dossier.moyennePreparation = null;
        if (!this.dossier.isSousTraitance)
          this.dossier.moyenneSoustraitancePreparation = null;
        if (!this.dossier.preparationPDA) this.dossier.modalitePDA = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
